import React from 'react';
import ReactDOM from 'react-dom';
import MonthlyTrendProfile from '../components/MonthlyTrendProfile';
import getQueryParams from '../utils/getQueryParams';

window.HuntUI = {};

window.HuntUI.TempProfile = ({props, selector}) => {
    ReactDOM.render(
        <MonthlyTrendProfile {...props}  />,
        window.document.querySelector(selector)
    );
};

window.HuntUI.PrecipProfile = ({props, selector}) => {
    ReactDOM.render(
        <MonthlyTrendProfile {...props}  />,
        window.document.querySelector(selector)
    );
};

window.util = {getQueryParams};
